
<!--  --------------- DESKTOP -----------------------  -->

<nav class="navbar navbar-expand-md navbar-stem sub-menu" [class.open]='showMobileMenu'>
  <div class="container navigazione-mobile">
    <ul class="navbar-nav d-md-none">
      <li class="nav-item">
          <a class="cart-icon btn text-white" (click)="showMobileMenu = !showMobileMenu">
            <i *ngIf="!showMobileMenu" class="fas fa-bars"></i>
            <i *ngIf="showMobileMenu" class="fas fa-times"></i>
          </a>
      </li>
    </ul>

    <a class="navbar-brand sticky-elements" [class.d-md-none]="!scrolled" [appHref]="'/'">
      <img alt="Menu" src="assets/img/logo-stem-bianco.webp" class="logo-desktop mr-lg-4">
    </a>

    <div class="collapse navbar-collapse" id="navbar-stem">
      <ul class="navbar-nav align-items-center">
        <li *ngFor="let voce of ( showHeaderSecondario ? menuSecondario :  menu)" class="nav-item" [class.dropdown]="voce.figli?.length > 0">
          <app-menu-voce-menu [voce]="voce" class="nav-link pointer" [class.dropdown-toggle]="voce.figli?.length > 0" (click)="voce.open = !voce.open"></app-menu-voce-menu>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown" [class.show]="voce.open" *ngIf="voce.figli?.length > 0">

            <li *ngFor="let voceFiglio of voce.figli" class="nav-item" [class.dropdown-submenu]="voceFiglio.figli?.length > 0">
              <app-menu-voce-menu [voce]="voceFiglio" [isSecondoLivelloDesktop]="true" (click)="voceFiglioClicked(voce, voceFiglio)"></app-menu-voce-menu>
              <ul aria-labelledby="dropdownMenu2" class="dropdown-menu border-0 shadow" [class.show]="voceFiglio.open" *ngIf="voceFiglio.figli?.length > 0">
                <li class="nav-item px-3" *ngFor="let voceNipote of voceFiglio.figli">
                  <app-menu-voce-menu [voce]="voceNipote"></app-menu-voce-menu>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto align-items-center">
        <li class="nav-item" *ngIf="!logged">
          <a class="nav-link no-login" (click)="accedi()">{{'ACCEDI_O_CREA_UN_ACCOUNT' | translate | htmlToText}}</a>
        </li>
        <li class="nav-item" *ngIf="logged">
          <a class="nav-link no-login" appHref="/area-riservata" >{{user.nome + ' ' + user.cognome}}</a>
        </li>
        <li class="nav-item" *ngIf="logged">
          <a class="nav-link no-login" (click)="logout()" >{{'LOGOUT' | translate | htmlToText}}</a>
        </li>
        <li class="nav-item maschera" [class.d-md-none]="!scrolled">
          <a class="cart-icon btn nav-link p-0" appHref="/carrello"><i class="fas fa-shopping-cart icon-single"></i> <span class="badge badge-danger">{{totaleCarrello}}</span></a>
        </li>
      </ul>
    </div>
    <ul class="navbar-nav d-md-none">
      <li class="nav-item">
          <a class="cart-icon btn text-white pl-0 pr-0" appHref="/carrello"><i class="fas fa-shopping-cart icon-single"></i> <span class="badge badge-danger">{{totaleCarrello}}</span></a>
        </li>
    </ul>
  </div>
</nav>


<!--  --------------- MOBILE -----------------------  -->


<div class="sm_menu_outer slide" [class.active]="showMobileMenu">
  <nav class="mobile_menu" >
    <div class="header-mobile-menu">
      <!-- <form class="form-inline form-menu my-4">
        <input class="form-control mx-auto" type="search" placeholder="Chercher" aria-label="Search">
        <button class="btn btn-search my-2 my-sm-0" type="submit"><i class="fas fa-search"></i></button>
      </form>-->
      <div class="form-newsletter form-inline form-menu mt-4 mb-2 my-lg-0 ml-auto">
        <div class="input-group mx-auto">
          <input type="text" class="form-control" (keydown.enter)="cerca()" placeholder="{{'CERCA' | translate | htmlToText}}" name="ricerca" [(ngModel)]="termineRicerca">
          <div class="input-group-append">
            <button class="btn btn-stem" type="button" (click)="cerca()" ><i class="fas fa-search mb-2"></i></button>
          </div>
        </div>
      </div>

      <div class="nav-item" *ngIf="!logged">
        <a class="nav-link no-login text-center" (click)="accedi()">{{'ACCEDI_O_CREA_UN_ACCOUNT' | translate | htmlToText}}</a>
      </div>
      <div class="nav-item" *ngIf="logged">
        <a class="nav-link no-login text-center" appHref="/area-riservata" >{{user.nome + ' ' + user.cognome}}</a>
      </div>
      <div class="nav-item" *ngIf="logged">
        <a class="nav-link no-login text-center" (click)="logout()">{{'LOGOUT' | translate | htmlToText}}</a>
      </div>
    </div>
    <ul>
      <li *ngFor="let voce of menu" [class.hasChild]="voce.figli?.length > 0" [class.active]="voce.open" (click)="voce.open = true" class="pointer">
        <a><app-menu-voce-menu [voce]="voce"></app-menu-voce-menu></a>
        <ul class="submenu" *ngIf="voce.figli?.length > 0">
          <li class="back" (click)="$event.stopPropagation(); voce.open = false">
            <a>{{voce.titolo}}</a>
          </li>
          <li *ngFor="let voceFiglio of voce.figli" [class.hasChild]="voceFiglio.figli?.length > 0" [class.active]="voceFiglio.open" (click)="voceFiglio.open = true">
            <a><app-menu-voce-menu [voce]="voceFiglio"></app-menu-voce-menu></a>
            <ul class="submenu" *ngIf="voceFiglio.figli?.length > 0">
              <li class="back" (click)="$event.stopPropagation(); voceFiglio.open = false">
                <a>{{voceFiglio.titolo}}</a>
              </li>
              <li *ngFor="let voceNipote of voceFiglio.figli">
                <a><app-menu-voce-menu [voce]="voceNipote"></app-menu-voce-menu></a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</div>
